import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import { ModalContext } from 'App';
import CmsContext from 'context/CmsContext';
import moment from 'moment';
import PrintIndividualCedula from './PrintIndividualCedula';
// import { computeCedulaInterest } from '../../helpers';
import UpdateModal from '../components/UpdateModal';
import ViewORModal from '../components/ViewORModal'
import VerifyReceipt from '../components/VerifyReceipt';
import RegenerateIndividualCedula from './RegenerateIndividualCedula';
import UpdateAmountModal from './UpdateAmountModal';
import * as action from '../action';
import * as c from '../constant';

function IndividualContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  onApprove,
  taxpayer,
  onTagAsPrinted,
  taggingAsPrinted,
  assessting,
  approving,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')

  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;
  const permissions = getJson('permissions');

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = cString => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const isEmployed = _.get(taxpayer, 'is_employed_individual');

  const taxAmounts = [
    parseFloat(_.get(taxpayer, 'additional_residence_tax_1')) || 0,
    parseFloat(_.get(taxpayer, 'additional_residence_tax_2')) || 0,
    parseFloat(_.get(taxpayer, 'additional_residence_tax_3')) || 0,
  ];
  const taxAmountsCdl = [
    parseFloat(_.get(taxpayer, 'additional_residence_tax_cedula_1') || 0),
    parseFloat(_.get(taxpayer, 'additional_residence_tax_cedula_2') || 0),
    parseFloat(_.get(taxpayer, 'additional_residence_tax_cedula_3') || 0),
  ];

  const onPrintCedula = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      // content: <PrintIndividualCedula data={data} id={data.id} />,
      content: <PrintIndividualCedula data={data} id={selectedTransaction} />,
      title: 'Print Cedula Individual',
      modalSize: 'modal-md',
    });
  };

  const computeCedulaInterest = (total, interestRate) => {
    const baseInterestRate = interestRate || 0.02;
    // const now = new Date();
    const currentMonth = moment(
      _.get(transactionInfo, 'attributes.created_at')
    ).format('MM');
    // now.getMonth() + 1;

    const monthlyInterestRate = +currentMonth * baseInterestRate;

    if (currentMonth > 2) {
      return {
        total: total * monthlyInterestRate + total,
        interest: total * monthlyInterestRate,
        interest_percentage: monthlyInterestRate,
      };
    }

    return {
      total,
      interest: 0,
      interest_percentage: 0,
    };
  };

  const totalInd = _.sum(taxAmounts);
  const totalIndCdlMax = () => {
    const isEmployedMaxAmount = isEmployed ? 'CEDULA_INDIVIDUAL_EMPLOYED_TOTAL_MAX_AMOUNT' : 'CEDULA_INDIVIDUAL_UNEMPLOYED_TOTAL_MAX_AMOUNT'
    if (_.get(CMS_COMPONENTS, isEmployedMaxAmount)
    && _.get(CMS_COMPONENTS, isEmployedMaxAmount) < _.sum(taxAmountsCdl)) {
      return _.get(CMS_COMPONENTS, isEmployedMaxAmount) 
    }
    return _.sum(taxAmountsCdl) 
  } 
  const totalIndCdl =
    +totalIndCdlMax() + +_.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_BASIC_AMOUNT');
  const serialNo =
    _.get(
      transactionInfo,
      'included.module.attributes.serial_number_complete'
    ) || 0;

  const totalWithInterest = computeCedulaInterest(
    totalIndCdl,
    +_.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_BASE_INTEREST_RATE')
  );

  const showVerifyReceipt = status => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'FOR PICK-UP',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ].includes(status);
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={taxpayer}
          moduleId={data.attributes.module_id}
          transactId={data.id}
          validId={data.attributes.valid_id_to_present}
        />
      ),
      title: 'Update Cedula',
      modalSize: 'modal-lg',
    });
  };

  const handleViewOR = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ViewORModal
          data={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `View OR`,
      modalSize: 'modal-lg',
    });
  };

  const handleVerifyReceipt = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleRegenerateCedula = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <RegenerateIndividualCedula data={data} id={data.id} />,
      title: 'Regenerate Individual Cedula',
      modalSize: 'modal-md',
    });
  };

  const updateAmount = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateAmountModal
          data={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Update Amount`,
      modalSize: 'modal-md',
    });
  };

  const tStatus = _.get(transactionInfo, 'attributes.transaction_status');

  // const getTotalAmountPaid = () => {
  //   // employed total amount paid
  //   if (_.get(taxpayer, 'is_employed_individual') === 1
  //     && _.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_EMPLOYED_MAX_TOTAL_AMOUNT_PAID')
  //     && parseFloat(totalWithInterest.total, 10) > parseFloat(_.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_EMPLOYED_MAX_TOTAL_AMOUNT_PAID'), 10)) {
  //     return +_.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_EMPLOYED_MAX_TOTAL_AMOUNT_PAID')
  //   }

  //   // unemployed total amount paid
  //   if (_.get(taxpayer, 'is_employed_individual') === 0
  //     && _.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_UNEMPLOYED_MAX_TOTAL_AMOUNT_PAID')
  //     && parseFloat(totalWithInterest.total, 10) > parseFloat(_.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_UNEMPLOYED_MAX_TOTAL_AMOUNT_PAID'), 10)) {
  //     return +_.get(CMS_COMPONENTS, 'CEDULA_INDIVIDUAL_UNEMPLOYED_MAX_TOTAL_AMOUNT_PAID')
  //   }

  //   return totalWithInterest.total
  // }

  // const cedulaInterest = +_.get(transactionInfo, 'attributes.amount') - totalIndCdl

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {getInitials(
                          `${_.get(taxpayer, 'first_name')} ${_.get(
                            taxpayer,
                            'middle_name'
                          )} ${_.get(taxpayer, 'last_name')}`
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${_.get(
                          taxpayer,
                          'middle_name'
                        ) || ''} ${_.get(taxpayer, 'last_name') || ''} ${_.get(
                          taxpayer,
                          'extension_name'
                        ) || ''}`}
                      </h1>
                    </div>
                  </div>

                  <div className="d-flex ml-auto justify-content-end mb-3">
                    {_.get(transactionInfo, 'attributes.status') === 'PAID' && _.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan' ? (
                      <button
                        disabled={taggingAsPrinted}
                        type="button"
                        onClick={handleViewOR}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                      >
                        {taggingAsPrinted ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            View OR
                          </>
                        )}
                      </button>
                    ) : (
                      ''
                    )}
                    {showVerifyReceipt(tStatus) && (
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn font-weight-bold btn-primary cms-bg-color-primary cms-outline-primary  mr-1"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    )}
                    {tStatus === 'PRINTED' && serialNo !== 0 ? (
                      <button
                        disabled={approving || assessting}
                        type="button"
                        onClick={onApprove(transactionInfo)}
                        className="btn gen-btn font-weight-bold btn-primary cms-bg-color-primary cms-outline-primary  "
                      >
                        {approving || assessting ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Tag as Received &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </>
                        )}
                      </button>
                    ) : (
                      ''
                    )}
                    {tStatus === 'FOR PICK-UP' && serialNo !== 0 ? (
                      <button
                        disabled={taggingAsPrinted || assessting}
                        type="button"
                        onClick={onTagAsPrinted(transactionInfo)}
                        className="btn gen-btn font-weight-bold btn-primary cms-bg-color-primary cms-outline-primary "
                      >
                        {taggingAsPrinted || assessting ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Tag as Printed &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </>
                        )}
                      </button>
                    ) : (
                      ''
                    )}
                    &nbsp;
                    {tStatus === 'FOR PICK-UP' && serialNo === 0 ? (
                      <button
                        type="button"
                        onClick={onPrintCedula(transactionInfo)}
                        className="btn gen-btn font-weight-bold btn-success"
                      >
                        <i className="fas fa-print mr-2" /> PRINT CEDULA 
                      </button>
                    ) : (
                      ''
                    )}
                    {tStatus === 'FOR PICK-UP' && !_.isEmpty(serialNo) && Acl(permissions, [
                      'REGENERATE CEDULA',
                    ]) ? (
                      <button
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                        onClick={handleRegenerateCedula(transactionInfo)}
                        type="button"
                      >
                        REGENERATE CEDULA
                      </button>
                    ) : (
                      ''
                    )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan' &&
                    Acl(permissions, ['CEDULA INDIVIDUAL UPDATE AMOUNT']) &&
                    _.get(transactionInfo, 'attributes.status') === 'PAID' &&
                    (['RECEIVED', 'PRINTED'].indexOf(tStatus) === -1) ? (
                      <button
                        type="button"
                        onClick={updateAmount}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                      >
                        Update Amount
                      </button>
                    ) : (
                      ''
                    )}
                  </div>

                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Information</Tab>
                      <Tab>Tax</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        module="cdl"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        <div className="row justify-content-end mr-2">
                          {(Acl(permissions, [
                            'VIEW CEDULA INDIVIDUAL EDIT INFORMATION',
                          ]) && (['RECEIVED', 'PRINTED'].indexOf(tStatus) === -1))
                            && (
                              <button
                                disabled={isLoading}
                                type="button"
                                onClick={handleEdit(transactionInfo)}
                                className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                              >
                                {isLoading ? (
                                  <i className="fa fa-spin fa-spinner" />
                                ) : (
                                  <>Edit Information</>
                                )}
                              </button>
                            )}
                        </div>
                        <table className="transaction-table table table-borderless table-sm ">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="250">
                                Last Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'last_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Middle Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'middle_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                First Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'first_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Extension Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'extension_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Tax Payer Account No:
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'tax_payer_account_number'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Address
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'region_name') || '--'}
                                  {''}
                                  {_.get(taxpayer, 'province_name') ||
                                    '--'}{' '}
                                  {_.get(taxpayer, 'municipality_name') || '--'}{' '}
                                  {_.get(taxpayer, 'barangay_name') || '--'}{' '}
                                  {_.get(taxpayer, 'street') || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Is Employed
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>{isEmployed ? 'YES' : 'NO'}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Gender
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'gender') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Civil Status
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'civil_status') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Citizenship
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'citizenship_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                ACR No. (if alien)
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'acr_number') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Place of Birth
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_region_name'
                                    ) || '--'
                                  ).toUpperCase()}{' '}
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_province_name'
                                    ) || '--'
                                  ).toUpperCase()}{' '}
                                  {(
                                    _.get(
                                      taxpayer,
                                      'place_of_birth_municipality_name'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Date of Birth
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>{_.get(taxpayer, 'birth_date') || '--'}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Profession/Occupation Business
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'profession_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Height
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'height') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Weight
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'weight') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Residence Tax Due
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'residence_tax_due') || '--'}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="p-3">
                        <div className="full-group border-bottom">
                          <div className="form-row">
                            <div className="form-input-group col-12 col-md-6 border-right">
                              <label className="full-label mb-2">
                                ADDITIONAL RESIDENCE TAX on the following items
                                owned or earned in the Philippines (Tax not
                                exceeded P5,000.00)
                              </label>
                            </div>
                            <div className="form-input-group col-12 col-md-3 border-right d-flex justify-content-center">
                              <label
                                htmlFor="height"
                                className="full-label mb-0"
                              >
                                TAXABLE AMOUNT
                              </label>
                            </div>
                            <div className="form-input-group col-12 col-md-3 d-flex justify-content-center">
                              <label
                                htmlFor="height"
                                className="full-label mb-0"
                              >
                                CEDULA AMOUNT
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="full-group border-bottom">
                          <div className="form-row">
                            <div className="form-input-group col-12 col-md-6 border-right">
                              <label
                                htmlFor="profession"
                                className="full-label mb-2 mt-2"
                              >
                                {_.get(
                                  CMS_COMPONENTS,
                                  'CEDULA_INDIVIDUAL_DESCRIPTION_1'
                                )}
                              </label>
                            </div>
                            <div className="form-input-group col-12 col-md-3 border-right">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {_.get(
                                  taxpayer,
                                  'additional_residence_tax_1_human'
                                ) || '--'}
                              </span>
                            </div>
                            <div className="form-input-group col-12 col-md-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {_.get(
                                  taxpayer,
                                  'additional_residence_tax_cedula_1_human'
                                ) || '--'}
                              </span>
                            </div>
                          </div>
                        </div>
                        {!_.get(
                          CMS_COMPONENTS,
                          'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX'
                        )
                          && (
                            <div className="full-group border-bottom">
                              <div className="form-row">
                                <div className="form-input-group col-12 col-md-6 border-right">
                                  <label
                                    htmlFor="profession"
                                    className="full-label mb-2 mt-2"
                                  >
                                    {_.get(
                                      CMS_COMPONENTS,
                                      'CEDULA_INDIVIDUAL_DESCRIPTION_2'
                                    )}
                                  </label>
                                </div>
                                <div className="form-input-group col-12 col-md-3 border-right">
                                  <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                    {_.get(
                                      taxpayer,
                                      'additional_residence_tax_2_human'
                                    ) || '--'}
                                  </span>
                                </div>
                                <div className="form-input-group col-12 col-md-3">
                                  <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                    {_.get(
                                      taxpayer,
                                      'additional_residence_tax_cedula_2_human'
                                    ) || '--'}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        {!_.get(
                          CMS_COMPONENTS,
                          'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX'
                        )
                          && (
                            <div className="full-group border-bottom">
                              <div className="form-row">
                                <div className="form-input-group col-12 col-md-6 border-right">
                                  <label
                                    htmlFor="profession"
                                    className="full-label mb-2 mt-2"
                                  >
                                    {_.get(
                                      CMS_COMPONENTS,
                                      'CEDULA_INDIVIDUAL_DESCRIPTION_3'
                                    )}
                                  </label>
                                </div>
                                <div className="form-input-group col-12 col-md-3 border-right">
                                  <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                    {_.get(
                                      taxpayer,
                                      'additional_residence_tax_3_human'
                                    ) || '--'}
                                  </span>
                                </div>
                                <div className="form-input-group col-12 col-md-3">
                                  <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                    {_.get(
                                      taxpayer,
                                      'additional_residence_tax_cedula_3_human'
                                    ) || '--'}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        <div className="full-group border-bottom">
                          <div className="form-row">
                            <div className="form-input-group col-12 col-md-6 border-right d-flex justify-content-end">
                              <label className="full-label mb-2 mt-2">
                                Total (+{'\u20B1'}{' '}
                                {
                                  +_.get(
                                    CMS_COMPONENTS,
                                    'CEDULA_INDIVIDUAL_BASIC_AMOUNT'
                                  )
                                }{' '}
                                Basic Amount)
                              </label>
                            </div>
                            <div className="form-input-group col-12 col-md-3 border-right">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}{' '}
                                {totalInd.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </div>
                            <div className="form-input-group col-12 col-md-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}{' '}
                                {totalIndCdl.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="full-group border-bottom">
                          <div className="form-row">
                            <div className="form-input-group col-12 col-md-6 border-right d-flex justify-content-end">
                              <label className="full-label mb-2 mt-2">
                                Interest (
                                {totalWithInterest.interest_percentage * 100}
                                %)
                              </label>
                            </div>
                            <div className="form-input-group col-12 col-md-3 border-right">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                &nbsp;
                              </span>
                            </div>
                            <div className="form-input-group col-12 col-md-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}{' '}
                                {totalWithInterest.interest.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="full-group border-bottom">
                          <div className="form-row">
                            <div className="form-input-group col-12 col-md-6 border-right d-flex justify-content-end">
                              <label className="full-label mb-2 mt-2">
                                Total Amount Paid
                              </label>
                            </div>
                            <div className="form-input-group col-12 col-md-3 border-right">
                              <span className="full-input text-right">
                                &nbsp;
                              </span>
                            </div>
                            <div className="form-input-group col-12 col-md-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}{' '}
                                {_.get(transactionInfo, 'attributes.amount')}
                                {/* {getTotalAmountPaid().toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )} */}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

IndividualContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  onApprove: PropTypes.instanceOf(Function).isRequired,
  onTagAsPrinted: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  taggingAsPrinted: PropTypes.bool.isRequired,
  assessting: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  taggingAsPrinted: api.loading.indexOf(c.TAG_AS_PRINTED_TRANSACTION) > -1,
  assessting: api.loading.indexOf(c.START_ASSESSMENT) > -1,
  approving: api.loading.indexOf(c.APPROVE_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(IndividualContent);
